// extracted by mini-css-extract-plugin
module.exports = {"container":"UsernameDisplay_container__320BY"};